import { render, staticRenderFns } from "./IconClassLanding.vue?vue&type=template&id=74ff469c"
import script from "./IconClassLanding.vue?vue&type=script&lang=js"
export * from "./IconClassLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports